import { PlainItemsSelector } from 'app/common/ui-next/plain-selector'
import type { SaleTypeItem } from 'app/filters/_static/saleTypes'

import { filterActions, useFilterOptions, useFilter } from '../../filterStore'

import { sortByTitle, emptyArray } from './helpers'

export const SaleTypeControl = () => {
  const ids = useFilter('saleTypeIds')
  const saleTypes = useFilterOptions('saleTypes')

  return (
    <PlainItemsSelector
      id="saleType"
      label="Тип продаж"
      header="Выбор типа продаж"
      items={saleTypes}
      selection={ids.draft || emptyArray}
      defaultSelection={ids.default || emptyArray}
      onChange={(selected) => filterActions.selectDraftSaleTypeIds(selected as Array<SaleTypeItem['id']> | undefined)}
      sortFunc={sortByTitle}
      skipUpperSpace
      multiple
    />
  )
}
